import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false, requireApproved = false }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === undefined) {
        return (
            <div className="min-h-[60vh] flex items-center justify-center" data-testid="loading-spinner">
                <div className="text-[#D4BC7C] font-serif text-lg tracking-widest animate-pulse">
                    Chargement...
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/connexion" state={{ from: location.pathname }} replace />;
    }

    if (requireAdmin && user.role !== "admin") {
        return <Navigate to="/" replace />;
    }

    if (requireApproved && user.role !== "admin" && user.status !== "approved") {
        return <Navigate to="/en-attente" replace />;
    }

    return children;
}
